import React, {Component} from "react";

import * as windowService from "../services/windowService";

import Error from "./Error";

export default class ErrorBoundary extends Component {
    constructor(props) {
        super(props);

        this.state = {
            error: null
        };
    }

    /**
     * Error boundaries don't catch errors for event handlers, asynchronous code and errors thrown in error boundary.
     */
    componentDidCatch(error) {
        windowService.logError("Error boundary ", error.stack);

        this.setState({
            error: error
        });
    }

    render() {
        if (this.state.error !== null) {
            return <Error error={this.state.error} />;
        }

        return this.props.children;
    }
}
